import type { insuranceImportApiSpec } from "@wingspanhq/wingspan-api-types";
import { insuranceImportService } from "./service";

type InsuranceImport = insuranceImportApiSpec.InsuranceImport;
type InsuranceImportUpdateRequest =
  insuranceImportApiSpec.InsuranceImportUpdateRequest;

export const updateInsuranceImport = async (
  insuranceImportId: string,
  request: InsuranceImportUpdateRequest
) => {
  const { data } = await insuranceImportService.patch<InsuranceImport>(
    `/${insuranceImportId}`,
    request
  );

  return data;
};
